import { render, staticRenderFns } from "./DashboardFocus.vue?vue&type=template&id=0bdad329&scoped=true"
import script from "./DashboardFocus.vue?vue&type=script&lang=js"
export * from "./DashboardFocus.vue?vue&type=script&lang=js"
import style0 from "./DashboardFocus.vue?vue&type=style&index=0&id=0bdad329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdad329",
  null
  
)

export default component.exports